import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"text-none",attrs:{"href":_vm.href,"target":"_blank","rel":"noopener","small":"","outlined":"","color":"primary"}},[_c(VIcon,{attrs:{"left":"","small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default",function(){return [_vm._v("Apri nel marketing")]}),_c(VIcon,{attrs:{"right":"","x-small":""}},[_vm._v("mdi-open-in-new")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }